import React from 'react';
import _ from 'lodash';
import {Field, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import {MoneyField} from 'components/Fields';

const formSelector = formValueSelector('createBookingExtension');

export const initialValues = state => {
  const selectedBookingValue = formSelector(state, 'booking');
  const roomDeposit = _.get(selectedBookingValue, 'object.roomDeposit');
  const pwRent = _.get(selectedBookingValue, 'object.pwRent');

  return {pwRent, roomDeposit};
};

const RentAndDepositSection = () => (
  <div>
    <FormField>
      <Label>Rent Per Week</Label>
      <Field name="pwRent" component={MoneyField} />
    </FormField>
    <FormField>
      <Label>Room Deposit</Label>
      <Field name="roomDeposit" component={MoneyField} />
    </FormField>
  </div>
);

export default RentAndDepositSection;
